export default __webpack_public_path__ + "static/media/gallery9.e60ac264.jpg";